// extracted by mini-css-extract-plugin
export default {"colnav":"Cg_colnav__Frnav","tg":"Cg_tg__fftrs","cg":"Cg_cg__s+WLG","it":"Cg_it__83MEW","tg1":"Cg_tg1__xnJIm"};